module.exports = {"Save":"a Mentés","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","Linked Credit Note/Proforma/Down payment":"Linked Credit Note/Proforma/Request to pay","Link Proforma / Down payment Invoice":"Link Proforma Invoice / Request to pay","Link Proforma/Down payment":"Link Proforma/Request to pay","Issue Down payment":"Issue Request to pay","search.hintText":"Írjon a kereséshez (* az összeshez)","shipment.packagingSender":"Feladó","Supplier":"Beszállító"}


//////////////////
// WEBPACK FOOTER
// ./src/core/common/locales/hu.json
// module id = 1352
// module chunks = 1